import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'components/ui/Button';
import Icon from 'components/AppIcon';

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
      <div className="text-center max-w-2xl">
        <div className="flex justify-center mb-6">
          <div className="relative">
            <Icon name="Rocket" className="w-24 h-24 text-primary" />
          </div>
        </div>

        <h2 className="text-3xl font-bold text-onBackground mb-4">Thank You for Visiting</h2>
        <p className="text-lg text-onBackground/90 mb-2">
          Pacific RBS Ltd is introducing full HR Management System for Private and Public Sector for 2026.
        </p>
        <p className="text-xl font-semibold text-primary mb-8">
          This website is launching soon!
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            variant="primary"
            icon={<Icon name="Home" />}
            iconPosition="left"
            onClick={handleGoHome}
          >
            Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
